import { useEffect, useRef } from "react"

import { useFormContext } from "react-hook-form"

import { LastUser } from "@/queries/hooks/useValidateWtpQuery"
import { isWtpFormatValid } from "@/utils/wtpUtils"

import { PassHolderFormData } from "../../../schema"

type UseImageAutofillProps = {
  lastUser: LastUser | undefined
  wtpNumber: string
}

export const useImageAutofill = ({
  lastUser,
  wtpNumber,
}: UseImageAutofillProps) => {
  const { setValue, clearErrors } = useFormContext<PassHolderFormData>()

  const processedImageIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (!wtpNumber || !isWtpFormatValid(wtpNumber) || !lastUser) {
      processedImageIdRef.current = null
      return
    }

    const hasImageData =
      lastUser.idImageData && lastUser.idImageData.trim() !== ""
    const hasImageId = lastUser.imageId !== null && lastUser.imageId !== ""

    if (hasImageData && hasImageId) {
      if (lastUser.imageId !== processedImageIdRef.current) {
        const base64WithPrefix = lastUser.idImageData.startsWith("data:")
          ? lastUser.idImageData
          : `data:image/jpeg;base64,${lastUser.idImageData}`

        setValue(
          "passHolderImage",
          {
            id: "",
            base64: base64WithPrefix,
            fileName: "",
          },
          { shouldValidate: false, shouldDirty: true }
        )

        setValue("exitingPhotoId", lastUser.imageId, {
          shouldValidate: false,
          shouldDirty: true,
        })

        clearErrors("passHolderImage")

        processedImageIdRef.current = lastUser.imageId
      }
    } else {
      setValue("passHolderImage", undefined, {
        shouldValidate: false,
        shouldDirty: true,
      })
      setValue("exitingPhotoId", null, {
        shouldValidate: false,
        shouldDirty: true,
      })
      clearErrors("passHolderImage")
      processedImageIdRef.current = null
    }
  }, [lastUser, wtpNumber, setValue, clearErrors])
}
